import React from 'react';
import { Button } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { FilterAltIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';

const FilterButton = ({ onClick, initPlaceFilterValues, inspectionSubjectsFilter }) => {
  return (
    <Button
      onClick={onClick}
      variant="outlined"
      endIcon={<FilterAltIcon />}
      color={
        JSON.stringify(initPlaceFilterValues) === JSON.stringify(inspectionSubjectsFilter)
          ? 'primary'
          : 'warning'
      }
    >
      <ButtonSpan>
        <FormattedMessage id="button.filter" />
      </ButtonSpan>
    </Button>
  );
};

export default FilterButton;
